import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import PaymentMethodPopup from '../copmponents/PaymentMethodPopup';
import SuccessAnimation from '../copmponents/SuccessAnimation';
import PaymentFailure from '../copmponents/PaymentFailure';
import { isMobileDevice } from '../../util/device';

const MembershipFeePage = () => {
	const [showPaymentPopup, setShowPaymentPopup] = useState(false);
	const [currentStep, setCurrentStep] = useState('content');
	const [statusMessage, setStatusMessage] = useState('');
	const [isCheckingMembership, setIsCheckingMembership] = useState(true);
	const [isMember, setIsMember] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		let isMounted = true;

		const checkMembershipStatus = async () => {
			try {
				const response = await axios.get('dashboard/member/member_self');
				const data = response?.data;
				const activeDues =
					data?.activeDues ??
					data?.member?.activeDues ??
					data?.data?.activeDues ??
					false;

				if (activeDues) {
					setIsMember(true);
				}
			} catch (error) {
				// If the request fails, keep the user on the page.
			}

			if (isMounted) {
				setIsCheckingMembership(false);
			}
		};

		checkMembershipStatus();

		return () => {
			isMounted = false;
		};
	}, [navigate]);

	if (isCheckingMembership) {
		return null;
	}

	const isMobile = isMobileDevice();

	if (currentStep === 'success') {
		return (
			<SuccessAnimation
				onNext={() => setCurrentStep('content')}
				titlerror={statusMessage || 'התשלום בוצע בהצלחה'}
			/>
		);
	}

	if (currentStep === 'error') {
		return (
			<PaymentFailure
				onClose={() => setCurrentStep('content')}
				error={statusMessage}
				titlerror="התשלום נכשל"
			/>
		);
	}

	return (
		<div className="bg-white p-4 min-h-[70vh]" dir="rtl">
			<div className="bg-white rounded-xl shadow-lg w-full max-w-md mx-auto p-6 relative">
				{isMember && (
					<div className="absolute inset-0 bg-white/80 backdrop-blur-[1px] rounded-xl flex items-center justify-center p-6">
						<button
							onClick={() => navigate(isMobile ? '/Mobile' : '/')}
							className="w-full bg-gradient-to-l from-blue-600 to-sky-500 text-white py-3 rounded-xl font-semibold shadow-md hover:shadow-lg hover:from-blue-700 hover:to-sky-600 transition-all duration-200 ring-1 ring-blue-200"
						>
							ממונה יקר, אתה כבר רשום
						</button>
					</div>
				)}
				{/* Title */}
				<h2 className="text-xl font-bold text-blue-700 text-center mb-3">
					ממונה יקר/ה שלום רב!
				</h2>

				{/* Body text */}
				<p className="text-gray-700 text-sm text-center leading-relaxed mb-4">
					טרם שילמת דמי חבר שנתיים,
					<br />
					תשלום דמי החבר מקנה לכל שנה קלנדרית :
				</p>

				{/* Bullet points */}
				<ul className="text-gray-600 text-sm mb-5 space-y-1 text-right">
					<li className="flex items-start gap-2 justify-end">
						<span className="text-green-500">✔</span>
						<span>
							זכאות להשתתפות ב 2 ימי כשירות לבחירתכם בשווי של 100 ₪ כ"א.
						</span>
					</li>
					<li className="flex items-start gap-2 justify-end">
						<span className="text-green-500">✔</span>
						<span>השתתפות בימי עיון והכשרות לממונים במחיר מוזל</span>
					</li>
					<li className="flex items-start gap-2 justify-end">
						<span className="text-green-500">✔</span>
						<span>
							הוראת קבע פעילה תאפשר את תשלום דמי החבר באופן אוטומטי בתחילת כל שנה
						</span>
					</li>
				</ul>

				<p className="text-gray-700 text-sm text-center leading-relaxed mb-3">
					"ביחד נעשה ונצליח"
					<br />
					בברכה
					<br />
					לשכת ממוני הבטיחות - מקצוענים זה אנחנו
				</p>

				{/* Pay button */}
				<button
					onClick={() => setShowPaymentPopup(true)}
					className="w-full bg-blue-600 text-white py-2 rounded-lg font-semibold hover:bg-blue-700 transition shadow"
				>
					לתשלום לדמי החבר
				</button>

				{/* Later */}
				<button
					onClick={() => navigate(isMobile ? '/Mobile' : '/')}
					className="w-full text-gray-500 text-xs mt-3 underline"
				>
					לא עכשיו
				</button>
			</div>

			<PaymentMethodPopup
				show={showPaymentPopup}
				onClose={() => setShowPaymentPopup(false)}
				onNext={(message) => {
					setShowPaymentPopup(false);
					setStatusMessage(message);
					setCurrentStep('success');
				}}
				onError={(message) => {
					setShowPaymentPopup(false);
					setStatusMessage(message);
					setCurrentStep('error');
				}}
			/>
		</div>
	);
};

export default MembershipFeePage;
